import React, { useEffect, useState } from 'react';
import { Plus, Pencil, Trash2, UserCog, Shield } from 'lucide-react';
import { api } from '../api';
import { PageLoading, Modal, useToast, Confirm } from '../components/ui';

const empty = { username: '', password: '', email: '', isAdmin: false, personId: '' };

export default function Accounts() {
  const toast = useToast();
  const [users, setUsers] = useState(null);
  const [people, setPeople] = useState([]);
  const [edit, setEdit] = useState(null);
  const [del, setDel] = useState(null);

  const load = () => api.get('/users').then((d) => setUsers(d.users));
  useEffect(() => { load(); api.get('/personnel').then((d) => setPeople(d.personnel)); }, []);
  if (!users) return <PageLoading />;

  const save = async () => {
    if (!edit.username) return toast('Benutzername erforderlich', 'err');
    if (!edit.id && (!edit.password || edit.password.length < 8)) return toast('Passwort: mind. 8 Zeichen', 'err');
    const body = { username: edit.username, email: edit.email, isAdmin: edit.isAdmin, personId: edit.personId || null };
    if (edit.password) body.password = edit.password;
    try {
      if (edit.id) await api.put(`/users/${edit.id}`, body);
      else await api.post('/users', body);
      setEdit(null); load(); toast('Gespeichert');
    } catch (e) { toast(e.message, 'err'); }
  };
  const remove = async (id) => { try { await api.del(`/users/${id}`); load(); toast('Gelöscht'); } catch (e) { toast(e.message, 'err'); } };

  return (
    <>
      <div className="page-head">
        <div><h1>Accounts</h1><div className="sub">Login-Zugänge für dieses Portal (unabhängig von anderen Diensten)</div></div>
        <div className="toolbar"><button className="btn btn-primary" onClick={() => setEdit({ ...empty })}><Plus size={16} /> Neuer Account</button></div>
      </div>

      <div className="card">
        <div className="table-wrap">
          <table className="table">
            <thead><tr><th>Benutzer</th><th>E-Mail</th><th>Rolle</th><th>verknüpfte Person</th><th></th></tr></thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id}>
                  <td><strong>{u.username}</strong></td>
                  <td className="muted small">{u.email || '—'}</td>
                  <td>{u.isAdmin ? <span className="badge badge-red"><Shield size={11} /> Admin</span> : <span className="badge badge-gray">Nutzer</span>}</td>
                  <td className="small">{u.personName || '—'}</td>
                  <td className="row-actions">
                    <button className="btn btn-secondary btn-sm" onClick={() => setEdit({ id: u.id, username: u.username, email: u.email || '', isAdmin: u.isAdmin, personId: u.personId || '', password: '' })}><Pencil size={14} /></button>
                    <button className="btn btn-danger btn-sm" onClick={() => setDel(u)}><Trash2 size={14} /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {edit && (
        <Modal title={edit.id ? 'Account bearbeiten' : 'Neuer Account'} onClose={() => setEdit(null)}
          footer={<><button className="btn btn-secondary" onClick={() => setEdit(null)}>Abbrechen</button><button className="btn btn-primary" onClick={save}>Speichern</button></>}>
          <div className="form-group"><label>Benutzername</label><input value={edit.username} disabled={!!edit.id} onChange={(e) => setEdit({ ...edit, username: e.target.value })} /></div>
          <div className="form-group"><label>E-Mail</label><input type="email" value={edit.email} onChange={(e) => setEdit({ ...edit, email: e.target.value })} /></div>
          <div className="form-group"><label>{edit.id ? 'Neues Passwort (leer = unverändert)' : 'Passwort'}</label><input type="password" value={edit.password} onChange={(e) => setEdit({ ...edit, password: e.target.value })} placeholder="mind. 8 Zeichen" /></div>
          <div className="form-group">
            <label>Verknüpfte Person (optional, für späteres Self-Service)</label>
            <select value={edit.personId} onChange={(e) => setEdit({ ...edit, personId: e.target.value })}>
              <option value="">— keine —</option>
              {people.map((p) => <option key={p.id} value={p.id}>{p.last_name}, {p.first_name}</option>)}
            </select>
          </div>
          <label className="checkbox-row"><input type="checkbox" checked={edit.isAdmin} onChange={(e) => setEdit({ ...edit, isAdmin: e.target.checked })} /> <Shield size={14} /> Administrator</label>
        </Modal>
      )}
      {del && <Confirm text={`Account „${del.username}" wirklich löschen?`} onConfirm={() => remove(del.id)} onClose={() => setDel(null)} />}
    </>
  );
}
